<div role="tabpanel" class="dados-convite">
    <form name="conviteForm" class="form-convite form-validate" [formGroup]="conviteForm" (ngSubmit)="salvar(0)">
        <div class="formulario">
            <div class="col-sm-12 col-md-12">
                <div class="mb-3 form-group">
                    <label>{{ 'buyer.convidar.dados-convite.empresa.label' | translate}}</label>
                    <input formControlName="company_name" type="text" class="form-control text-capitalize" maxlength="100" [ngClass]="{'is-invalid': displayMessage.company_name }">
                    @if (displayMessage.company_name) {
                        <span class="text-danger">
                            <p [innerHTML]="displayMessage.company_name"></p>
                        </span>
                    }
                </div>
            </div>
            <div class="col-sm-12 col-md-12">
                <div class="mb-3 form-group">
                    <label>{{ 'buyer.convidar.dados-convite.nome.label' | translate}}</label>
                    <input formControlName="seller_name" type="text" class="form-control text-capitalize" maxlength="100" [ngClass]="{'is-invalid': displayMessage.seller_name }">
                    @if (displayMessage.seller_name) {
                        <span class="text-danger">
                            <p [innerHTML]="displayMessage.seller_name"></p>
                        </span>
                    }
                </div>
            </div>
            <div class="col-sm-12 col-md-12">
                <div class="mb-3 form-group">
                    <label>{{ 'buyer.convidar.dados-convite.email.label' | translate}}</label>
                    <input formControlName="seller_email" type="email" class="form-control" maxlength="100" [ngClass]="{'is-invalid': displayMessage.seller_email }">
                    @if (displayMessage.seller_email) {
                        <span class="text-danger">
                            <p [innerHTML]="displayMessage.seller_email"></p>
                        </span>
                    }
                </div>
            </div>
            <div class="d-flex">
                <div class="col-sm-6 col-md-6">
                    <div class="mb-3 form-group">
                        <label>{{ 'buyer.convidar.dados-convite.telefone.label' | translate}}</label>
                        <input formControlName="seller_phone" type="text" class="form-control" telefone [textMask]="{mask: MASKS.phoneNumber.textMaskFunction}" [ngClass]="{'is-invalid': displayMessage.seller_phone }">
                        @if (displayMessage.seller_phone) {
                            <span class="text-danger">
                                <p [innerHTML]="displayMessage.seller_phone"></p>
                            </span>
                        }
                    </div>
                </div>
                <div class="col-sm-6 col-md-6">
                    <div class="mb-3 form-group">
                        <label>{{ 'buyer.convidar.dados-convite.whatsapp.label' | translate}}</label>
                        <input formControlName="seller_radio" type="text" class="form-control" telefone [textMask]="{mask: MASKS.phoneNumber.textMaskFunction}" [ngClass]="{'is-invalid': displayMessage.seller_radio }" />
                        @if (displayMessage.seller_radio) {
                            <span class="text-danger">
                                <p [innerHTML]="displayMessage.seller_radio"></p>
                            </span>
                        }
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-md-12">
                @if (!loading_local) {
                    <button id="salvar" type="submit" class="btn btn-primary btn-lg" [disabled]="!conviteForm.valid || !conviteForm.dirty ? 'disabled' : null">{{ 'buyer.convidar.dados-convite.botoes.convidar' | translate}}</button>
                }
            </div>
        </div>
    </form>
</div>
